module.exports = __webpack_public_path__ + "28b67065/img/upload-icon.9179ae4e.svg";